module.exports = __webpack_public_path__ + "img/other.f48cc699.jpg";